import { PsvProviderStatus } from "@api/shared-runtime/psv-review";
import { cn } from "@/lib/utils";

const ALL_PROVIDERS = "all";

const TABS: {
  value: PsvProviderStatus | typeof ALL_PROVIDERS;
  label: string;
}[] = [
  { value: ALL_PROVIDERS, label: "All providers" },
  { value: PsvProviderStatus.NotRun, label: "Not run" },
  { value: PsvProviderStatus.InProgress, label: "In progress" },
  { value: PsvProviderStatus.NeedsReview, label: "Needs review" },
  { value: PsvProviderStatus.Concern, label: "Concern" },
  { value: PsvProviderStatus.Verified, label: "Verified" },
];

/** Filters the roster by where each provider's latest verification stands. */
export function PsvStatusTabs({
  value,
  onChange,
}: {
  value?: PsvProviderStatus;
  onChange: (status: PsvProviderStatus | undefined) => void;
}) {
  const selected = value ?? ALL_PROVIDERS;
  return (
    <nav
      aria-label="Verification status"
      className="-mb-px flex overflow-x-auto"
    >
      {TABS.map((tab) => (
        <button
          key={tab.value}
          type="button"
          aria-current={selected === tab.value ? "page" : undefined}
          className={cn(
            "whitespace-nowrap border-b-2 px-3 py-3 text-sm font-medium transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
            selected === tab.value
              ? "border-primary text-primary"
              : "border-transparent text-muted-foreground hover:text-foreground",
          )}
          onClick={() =>
            onChange(tab.value === ALL_PROVIDERS ? undefined : tab.value)
          }
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
